/**
 * Root-action name pairs for the projects feature. The backend advertises
 * Owner-flavored names on Owner accounts and Agent-flavored names on Agent
 * accounts — same params and response envelope either way (verified against dev).
 *
 * Owner names come first: if a user ever exposes both sets, the broader
 * Owner view wins. Flipping that policy is a one-line change here.
 */
export const LIST_PROJECTS_ACTIONS = ['listDLProjects', 'listAgentDLProjects'];
export const GET_PROJECT_ACTIONS = ['getDLProject', 'getAgentDLProject'];
export const CREATE_PROJECT_ACTIONS = ['createDLProject', 'createAgentDLProject'];
